import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * Updates the Vastra product badge row when the selected variant changes.
 *
 * @extends {Component}
 */
class VastraProductBadges extends Component {
  connectedCallback() {
    super.connectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;

    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;

    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  updateBadges = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadges = event.detail.data.html.querySelector(
      `vastra-product-badges[data-block-id="${this.dataset.blockId}"]`
    );

    if (!newBadges) return;

    this.replaceChildren(...Array.from(newBadges.childNodes, (node) => node.cloneNode(true)));
  };
}

if (!customElements.get('vastra-product-badges')) {
  customElements.define('vastra-product-badges', VastraProductBadges);
}
